import React from 'react';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import { Card } from '../../../components';

const CardAgency = ({ data }) => (
  <Card className="dashboard-card dashboard-card--agency shadow-none">
    
    {data.map(obj => {
      const classNames = [
        'dashboard-card-item',
        obj.extra ? 'dashboard-card-item--extra' : '',
        obj.featured ? 'dashboard-card-item--bold' : ''
      ].join(' ');
      return (
        <NavLink to={obj.url || "#"} key={_.uniqueId()} className={classNames}>
          <div className="description">{obj.label}</div>
          <div className="count">{obj.total}</div>
        </NavLink>
      );
    })}
  </Card>
);

export default CardAgency;



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/card-agency.js